import { resolveTenant } from "./tenant";

const PREFIX = "myai_excel.bearer";

function bearerKey(): string | null {
  const t = resolveTenant();
  return t ? `${PREFIX}.${t}` : null;
}

export function getBearer(): string | null {
  if (typeof window === "undefined") return null;
  const k = bearerKey();
  if (!k) return null;
  return localStorage.getItem(k);
}

export function setBearer(token: string): void {
  if (typeof window === "undefined") return;
  const k = bearerKey();
  if (!k) return;
  if (!token) {
    localStorage.removeItem(k);
    return;
  }
  localStorage.setItem(k, token);
}

export function clearBearer(): void {
  if (typeof window === "undefined") return;
  const k = bearerKey();
  if (!k) return;
  localStorage.removeItem(k);
}

// Bearer format: base64("{mirror_id}:{credential_artifact_id}")
export function decodeMirrorId(): string | null {
  const token = getBearer();
  if (!token) return null;
  try {
    const decoded = atob(token);
    const colonIdx = decoded.indexOf(":");
    if (colonIdx < 1) return null;
    return decoded.slice(0, colonIdx);
  } catch {
    return null;
  }
}
